export default __webpack_public_path__ + "static/media/apple.a1ba246b.svg";